import cn from 'classnames';
import { useMemo } from 'react';

import { DateField } from '@src-common/view/adapters/DateField';
import { SelectField } from '@src-common/view/adapters/SelectField';
import { TextField } from '@src-common/view/adapters/TextField';

import s from './FilterItem.module.css';
import { IFilterItemProps } from './types';

const FilterItem = <FilterName extends string>({
  value,
  onChange,
  title,
  name,
  placeholder,
  options,
  type,
  icon,
  hasOneLineLabel,
  isCompact,
  fixedValue,
  isClearable,
}: IFilterItemProps<FilterName>) => {
  const titleElement = useMemo(
    () =>
      isCompact ? (
        ''
      ) : (
        <span className={cn(s.title, { [s.oneLine]: hasOneLineLabel })}>{title}</span>
      ),
    [isCompact, hasOneLineLabel, title],
  );

  if (type === 'select' && options) {
    return (
      <SelectField
        isDisabled={fixedValue !== undefined}
        title={titleElement}
        name={name}
        value={value[name] ?? ''}
        placeholder={isCompact ? title : placeholder}
        onChange={onChange as any}
        items={options}
        isClearable={isClearable}
      />
    );
  }

  if (type === 'date') {
    return (
      <DateField
        isDisabled={fixedValue !== undefined}
        title={titleElement}
        placeholder={isCompact ? title : placeholder}
        name={name}
        onChange={onChange}
        value={value[name] ?? null}
        startElem={icon}
      />
    );
  }

  return (
    <TextField
      isDisabled={fixedValue !== undefined}
      startElem={icon}
      title={titleElement}
      placeholder={isCompact ? title : placeholder}
      name={name}
      value={value[name] ?? ''}
      onChange={onChange}
    />
  );
};

export { FilterItem };
